import ArrowSubmitComponent from './pr-arrow-submit';

export default ArrowSubmitComponent;
